export default "<!-- Pan-Faktor -->\n<div>\n  <router-outlet></router-outlet>\n</div>"